import { configureStore } from '@reduxjs/toolkit';
import testExecutionsReducer from './Slices/TestExecutions';
import runTestsReducer from './Slices/RunTests';
import testResultsReducer from './Slices/TestResults';
import aiAnalysisReducer from './Slices/AIAnalysis';

export default configureStore({
  reducer: {
    testExecutions: testExecutionsReducer,
    runTests: runTestsReducer,
    testResults: testResultsReducer,
    aiAnalysis: aiAnalysisReducer,
  },
});
